import { Component, OnInit, Input } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';

@Component({
  selector: 'app-scale-summary',
  templateUrl: './scale-summary.component.html'
})
export class ScaleSummaryComponent implements OnInit {
  @Input() scaleResult:ScaleResult;
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/scale-summary/scale-summary.component.ts